import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { IEventTrigger } from "@formant/core/model/IEventTrigger";

import { appStore, eventTriggerStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { ActionButton } from "../ActionButton";

export interface IActionsProps {
    eventTrigger: IEventTrigger;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        return (
            <Buttons>
                <ActionButton icon="delete" onClicked={this.onDelete} />
            </Buttons>
        );
    }

    private onDelete = () => {
        appStore.setConfirm({
            title: "Delete event",
            message: "Delete this event?",
            onOk: async () => {
                await eventTriggerStore.disable(
                    defined(this.props.eventTrigger.id),
                );
                appStore.setSnackbar("Event deleted");
            },
        });
    };
}
